import React from 'react';
/* MUI */
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
/* Icons */
import CancelIcon from '@mui/icons-material/CancelOutlined';
import SearchIcon from '@mui/icons-material/Search';

export interface SearchTextProps {
  handleChange: (s: string) => void;
  padding: string;
  initialValue?: string | undefined | null;
}

export const SearchText = (props: SearchTextProps) => {
  const { handleChange, padding, initialValue } = props;
  const [searchTerm, setSearchTerm] = React.useState(initialValue ?? '');

  // Sync internal state with prop changes
  React.useEffect(() => {
    if (initialValue !== undefined && initialValue !== null) {
      setSearchTerm(initialValue);
    }
  }, [initialValue]);

  const onChange = (term: string) => {
    setSearchTerm(term);
    handleChange(term);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
    handleChange('');
  };

  return (
    <Box
      sx={{
        backgroundColor: '#f3f2f2',
        padding: `10px ${padding}`,
      }}
    >
      <TextField
        id="standard-search"
        placeholder="Search"
        type="search"
        color="secondary"
        fullWidth
        value={searchTerm}
        size={'small'}
        variant="outlined"
        onChange={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onChange(e.target.value);
        }}
        sx={{
          borderRadius: '4px',
          background: '#fff',
        }}
        InputProps={{
          type: 'text',
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <IconButton
              aria-label="clear search"
              onClick={handleClearSearch}
              edge="end"
            >
              {searchTerm.length ? <CancelIcon /> : null}
            </IconButton>
          ),
        }}
      />
    </Box>
  );
};
